import { reactive } from 'vue'
import axios from 'axios'
import authHeader from '@/services/auth-header'

/*
 * Náhľad súboru priamo v aplikácii (rovnaký ako pri konceptoch interných príkazov).
 * Prekryje hlavnú plochu; ľavý panel aj bočný panel s diskusiou ostanú viditeľné.
 * Otvára sa z hociktorej stránky:
 *   otvoritNahlad({
 *     nazov: 'zmluva.pdf',                       // podľa prípony sa vyberie spôsob zobrazenia
 *     nacitaj: () => Service.getBlob(id),          // obsah súboru (Promise<Blob>)
 *     stiahnut: () => Service.download(id),        // voliteľné - tlačidlo Stiahnuť
 *     podtitul: 'Smernica · 12. 10. 2026',          // voliteľné
 *     komentovat: ({ citacia, strana }) => …,      // voliteľné - ak má záznam diskusiu
 *     zvyraznenie: { citacia, strana },             // voliteľné - po otvorení nájsť a zvýrazniť
 *   })
 */
export const nahlad = reactive({
  otvoreny: false,
  nazov: '',
  podtitul: '',
  nacitaj: null,
  stiahnut: null,
  komentovat: null,
  zvyraznenie: null,
  verzia: 0,
})

export function otvoritNahlad(moznosti) {
  Object.assign(
    nahlad,
    { podtitul: '', stiahnut: null, komentovat: null, zvyraznenie: null },
    moznosti,
    { otvoreny: true, verzia: nahlad.verzia + 1 }
  )
}

export function zavrietNahlad() {
  nahlad.otvoreny = false
}

/** Obsah súboru z URL cez prihlásené API (auth hlavička) */
export function blobZUrl(url) {
  return axios.get(url, { headers: authHeader(), responseType: 'blob' }).then((response) => response.data)
}

/** Stiahnutie súboru z URL pod daným názvom (cez blob, aby fungovalo aj pre prihlásené API) */
export async function stiahnutZUrl(url, nazov) {
  const blob = await blobZUrl(url)
  const objektUrl = window.URL.createObjectURL(blob)
  const odkaz = document.createElement('a')
  odkaz.href = objektUrl
  odkaz.setAttribute('download', nazov || 'subor')
  document.body.appendChild(odkaz)
  odkaz.click()
  document.body.removeChild(odkaz)
  window.URL.revokeObjectURL(objektUrl)
}

/** Dá sa súbor s týmto názvom zobraziť v náhľade? (ostatné sa len stiahnu) */
const NAHLAD_PRIPONY = ['pdf', 'docx', 'xlsx', 'xls', 'ods', 'csv', 'pptx', 'txt', 'md', 'log', 'json', 'xml', 'jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg']
export function maNahlad(nazov) {
  const pripona = String(nazov || '').toLowerCase().split('.').pop()
  return NAHLAD_PRIPONY.includes(pripona)
}
